import React, { useContext } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { ROUTES } from '../../constants/routes';
import { userHasFn, SUB_APPS } from '../../utils/rbac';
import SubAppHeaderActions from '../../components/SubAppHeaderActions';

const navClass = ({ isActive }) =>
  `nav-link ${isActive ? 'active fw-semibold' : ''}`;

function RaiseTheSailLayout() {
  const { user } = useContext(AuthContext);
  const canChecklistAdmin = userHasFn(user, SUB_APPS.RAISE_THE_SAIL, 'admin');

  return (
    <div className="container-fluid mt-3 px-3 app-shell-page sub-app-white-nav">
      <div className="card app-card bg-white mb-3">
        <div className="card-body py-3">
          <div className="app-layout-bar d-flex flex-wrap justify-content-between align-items-center gap-2 mb-0 pb-0">
            <h1 className="app-layout-title mb-0">Raise The Sail Checklist</h1>
            <SubAppHeaderActions
              subAppHomePath={ROUTES.RAISE_THE_SAIL}
              subAppHomeLabel="Raise The Sail"
              navButtonClassName="btn btn-sm bg-white text-dark border"
            />
          </div>

          <ul className="nav nav-tabs mb-0 mt-3">
            <li className="nav-item">
              <NavLink to={ROUTES.RAISE_THE_SAIL} end className={navClass}>
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to={ROUTES.RAISE_THE_SAIL_REPORTS} className={navClass}>
                Reports
              </NavLink>
            </li>
            {canChecklistAdmin && (
              <li className="nav-item">
                <NavLink to={ROUTES.RAISE_THE_SAIL_ADMIN} className={navClass}>
                  Admin
                </NavLink>
              </li>
            )}
          </ul>
        </div>
      </div>

      <Outlet />
    </div>
  );
}

export default RaiseTheSailLayout;
